import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Config } from "../_store";

@Injectable({
    providedIn: "root",
})
export class PosService {
    purchaseOrders: any;

    constructor(private http: HttpClient) {}

    fetchPurchaseOrders(data: any) {
        return this.http.post(Config.urls.PURCHASEODERS, data);
    }

    fetchPurchaseOrdersList(data: any) {
        return this.http.post(Config.urls.PURCHASEODERS_LIST, data);
    }


    fetchPurchaseOrderDetails(data: any) {
        return this.http.post(Config.urls.PURCHASEODERS_DETAILS, data);
    }

    fetchPo(data: any) {
        return this.http.post(Config.urls.PURCHASEODERS, data);
    }

    fecthPod(data: any) {
        return this.http.post(Config.urls.MATERIALPOS, data);
    }

    setPos(data: any) {
        this.purchaseOrders = data;
    }

    getPos() {
        return this.purchaseOrders;
    }
}
